import { TelecomWaitingRoomEntryStatus } from '@montugroup/pms-api-contracts';
import { DateTime } from 'luxon';

const WAITING_ROOM_QUERY_KEY = 'waitingRoomQuery';
const defaultQueryDate = () => DateTime.now().toUTC().minus({ hours: 1 });

const clearWaitingRoomQuery = () => localStorage.removeItem(WAITING_ROOM_QUERY_KEY);

const setWaitingRoomQuery = (queuedSince: DateTime | undefined, status: TelecomWaitingRoomEntryStatus | undefined) => {
  localStorage.setItem(
    WAITING_ROOM_QUERY_KEY,
    JSON.stringify({
      queuedSince: (queuedSince ?? defaultQueryDate()).toFormat("yyyy-MM-dd'T'HH:mm:ss'Z'"),
      status: status ?? TelecomWaitingRoomEntryStatus.Waiting,
    }),
  );
};

const getWaitingRoomQuery = (): { queuedSince: string; status: TelecomWaitingRoomEntryStatus | undefined } => {
  let storedQuery = localStorage.getItem(WAITING_ROOM_QUERY_KEY);
  if (!storedQuery) {
    setWaitingRoomQuery(undefined, undefined);
    storedQuery = localStorage.getItem(WAITING_ROOM_QUERY_KEY);
  }
  return JSON.parse(storedQuery ?? '');
};

export const TelecomService = {
  clearWaitingRoomQuery,
  setWaitingRoomQuery,
  getWaitingRoomQuery,
};
